import React from 'react';
import axios from "axios";
import { connect } from "react-redux";
import { Container, Row, Col } from 'react-bootstrap'
import FormTemplate from "../common/form/FormTemplate.js";
import configData from "../../config/config.json";

const mapStateToProps = (state) => {
	return {
		currentUser: state.currentUserReducer
	};
}

class UserEntry extends React.Component {
	state = {
		id: 0,
		username: '',
		role: 'USER',
		firstName: '',
		lastName: '',
		company: '',
		address: '',
		city: '',
		state: '',
		zip: '',
		email: '',
		phoneInternational: '',
		phoneStandard: '',
		status: 'A',	
	}

	handleCancel = (event) => {
		event.preventDefault();
		this.props.history.push('/tenantAdmin/users');
	}

	handleSubmit = (event) => {
		event.preventDefault();

		this.props.history.push('/tenantAdmin/users');
	}

	componentDidMount() {

		axios.get(configData.LANDNOTIFICATION_SERVER_URL + "helperdata/multiTenantList", { withCredentials: true })
			.then(
				(response) => {
					const content = response.data.content;
					let codeDescriptionResultList = content.codeDescriptionResultList;
					this.setState({
						countyList: codeDescriptionResultList
					});
				},
				(error) => {
					alert("error");
					//   handleError(error, this.props.history);
				}
			);
		
		axios.get(configData.LANDNOTIFICATION_SERVER_URL + "userManager/user/" + this.props.match.params.id, { withCredentials: true })
			.then(
				(response) => {
					const content = response.data.content;
					this.setState({
						id: content.id,
						username: content.username,
						firstName: content.firstName,
						lastName: content.lastName,
						role: content.role,
						company: content.company,
						phoneFormatType: content.phoneFormatType,
						phoneStandard: content.phoneFormatType === 'STANDARD' ? content.phone: '',
						phoneInternational: content.phoneFormatType === 'INTERNATIONAL' ? content.phone: '',
						address: content.address,
						city: content.city,
						state: content.state,
						zip: content.zip,
						email: content.email,
						status: content.status,
					});

				},
				(error) => {
					console.log(error);
				}
			);
	}

	render() {
		let formGroupRows = [
			{
				formGroups: [{id: 'role', label: 'User Type', fieldType: 'text', value: this.state.role === 'TENANT' ? 'ADMIN' : this.state.role , disabled: true }]
			},
			{
				formGroups: [{ id: 'firstName', label: 'First Name', fieldType: 'text', value: this.state.firstName, disabled: true}, 
				             { id: 'lastName', label: 'Last Name', fieldType: 'text', value: this.state.lastName, disabled: true }]
			},
			{
				formGroups: [{ id: 'email', label: 'Email', fieldType: 'email', value: this.state.email, disabled: true,  style: {minWidth: 400} }]
			},
			{
				formGroups: [{ id: 'company', label: 'Company', fieldType: 'text', value: this.state.company ? this.state.company : ' ', disabled: true }]
			},
			{
				formGroups: [{ id: 'address', label: 'Address', fieldType: 'text', value: this.state.address ? this.state.address : ' ', disabled: true, style: {minWidth: 300} }]
			},
			{
				formGroups: [{ id: 'city', label: 'City', fieldType: 'text', value: this.state.city ? this.state.city : ' ', disabled: true }, { id: 'state', label: 'State', fieldType: 'text', value: this.state.state ? this.state.state : ' ', disabled: true }, { id: 'zip', label: 'Zip', fieldType: 'zip', style: {maxWidth: 80}, value: this.state.zip ? this.state.zip : ' ', disabled: true }]
			},
			{
				formGroups: [{ id: 'phoneStandard', label: 'Phone', fieldType: 'tel', value: this.state.phoneStandard ? this.state.phoneStandard : ' ', disabled: true, hideField: this.state.phoneFormatType !== 'STANDARD' },
							 { id: 'phoneInternational', label: 'Phone', fieldType: 'tel_international', value: this.state.phoneInternational ? this.state.phoneInternational : ' ', disabled: true, hideField: this.state.phoneFormatType !== 'INTERNATIONAL' } ]
			}
		]

		const formProps = {
			componentName: "User",
			pageHeading: this.state.username,
			formGroupRows: formGroupRows,
			primaryButtonLabel: 'Close',
			onSubmit: this.handleSubmit
		}

		return (
			<div style={{ marginRight: 80, marginLeft: 80, marginTop: 0 }}>
				<Container>
					<Row>
						<Col style={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 2, marginTop: 0 }}>
							<FormTemplate {...formProps} />
						</Col>
					</Row>
				</Container>
			</div>
		)
	}
}

export default connect(mapStateToProps)(UserEntry);